<template>
	<div class="admin" style="background-color: #f5f5f5;height: 700px; overflow: scroll;">
		<h3 style="padding: 15px 0px;">小程序用户管理</h3>


		<div class="middle-row around" style="width: 100%;">
			<div class="subinput middle-row around">
				<div class="input-group">
					<span class="input-group-addon">所属街道</span>
					<select name="" id="select" v-model="street" class="form-control">
						<option value="">全部街道</option>
						<option value="东山街道">东山街道</option>
						<option value="南黎街道">南黎街道</option>
						<option value="曲阳街道">曲阳街道</option>
						<option value="渠沟镇">渠沟镇</option>
						<option value="任圩街道">任圩街道</option>
						<option value="三堤口">三堤口</option>
						<option value="相南街道">相南街道</option>
						<option value="相山东街道">相山东街道</option>
						<option value="相山西街道">相山西街道</option>
						<option value="凤凰山经济开发区">凤凰山经济开发区</option>
					</select>
				</div>
			</div>
			<div class="subinput middle-row around">
				<div class="input-group">
					<span class="input-group-addon">账号/电话</span>
					<input type="text" v-model="keyword" class="form-control" placeholder="请输入账号/电话信息">
				</div>
			</div>
			<div class="subinput middle-row around">
				<div class="input-group">
					<button type="button" class="btn btn-success" @click="getAllLogin">搜索</button>
				</div>
			</div>
		</div>

		<div style="text-align: left;padding-left: 45px; line-height: 40px;"> <span
				style="border-left: 5px solid green; ">超级管理员</span> </div>
		<div class="userlist middle-row start">
			<div v-for="(login, i) in loginlist" v-if="login.typeId == 1" :key="i" class="user middle-row around">
				<div class="userleft middle-row center" style="width: 10%;">
					<i :class="login.typeId == '3' ? 'classone' : 'classtwo'" class="fa fa-user-circle fa-4x"></i>
				</div>
				<div class="usermiddle middle-column around" style="width:60%;align-items: flex-start;">
					<h5>名称:{{ login.ownerName }}</h5>
					<h5>账号:{{ login.account }}</h5>
					<h5>角色:超级管理员</h5>
				</div>
				<div class="userright middle-column around" style="width: 20%;">
					<a class="btn btn-warning" name="btn" @click="deleteUser(i)">删除账户</a>
					<a class="btn btn-success" name="btn" @click="resetPassword(i)">重置密码</a>
				</div>
			</div>
		</div>
		<div style="text-align: left;padding-left: 45px; line-height: 40px;"> <span
				style="border-left: 5px solid green; ">区域负责人</span> </div>
		<div class="userlist middle-row start">
			<div v-for="(login, i) in loginlist" v-if="login.typeId == 2" :key="i" class="user middle-row around">
				<div class="userleft middle-row center" style="width: 10%;">
					<i :class="login.typeId == '3' ? 'classone' : 'classtwo'" class="fa fa-user-circle fa-4x"></i>
				</div>
				<div class="usermiddle middle-column around" style="width: 60%;align-items: flex-start;">
					<h5>名称:{{ login.ownerName }}</h5>
					<h5>账号:{{ login.account }}</h5>
					<h5>角色:区域负责人</h5>
				</div>
				<div class="userright middle-column around" style="width: 20%;">
					<a class="btn btn-warning" name="btn" @click="deleteUser(i)">删除账户</a>
					<a class="btn btn-success" name="btn" @click="resetPassword(i)">重置密码</a>
				</div>
			</div>
		</div>
		<div style="text-align: left;padding-left: 45px; line-height: 40px;"> <span
				style="border-left: 5px solid green; ">清洗公司</span> </div>
		<div class="userlist middle-row start">
			<div v-for="(login, i) in loginlist" v-if="login.typeId == 3" :key="i" style="width:45%;"
				class="user middle-row around">
				<div class="userleft middle-row center" style="width:5%;">
					<i :class="login.typeId == '3' ? 'classone' : 'classtwo'" class="fa fa-user-circle fa-4x"></i>
				</div>
				<div class="usermiddle middle-column around" style="width:60%;align-items: flex-start;">
					<h5>名称:{{ login.ownerName }}</h5>
					<h5>账号:{{ login.account }}</h5>
					<h5>角色:清洗公司</h5>
					<h5>公司:{{ login.company }}</h5>

				</div>
				<div class="userright middle-column around" style="width:20%;">
					<a class="btn btn-warning" name="btn" @click="deleteUser(i)">删除账户</a>
					<a class="btn btn-success" name="btn" @click="resetPassword(i)">重置密码</a>
				</div>
			</div>
		</div>
		<div style="text-align: left;padding-left: 45px; line-height: 40px;"> <span
				style="border-left: 5px solid green; ">商户负责人</span> </div>
		<div class="userlist middle-row start">
			<div v-for="(login, i) in loginlist" v-if="login.typeId == 4" :key="i" class="user middle-row around">
				<div class="userleft middle-row center" style="width: 10%;">
					<i :class="login.typeId == '3' ? 'classone' : 'classtwo'" class="fa fa-user-circle fa-4x"></i>
				</div>
				<div class="usermiddle middle-column around" style="width:60%;align-items: flex-start;">
					<h5>名称:{{ login.ownerName }}</h5>
					<h5>账号:{{ login.account }}</h5>
					<h5>街道:{{ login.street }}</h5>
					<h5>角色:商户负责人</h5>
				</div>
				<div class="userright middle-column around" style="width: 20%;">
					<a class="btn btn-warning" name="btn" @click="deleteUser(i)">删除账户</a>
					<a class="btn btn-success" name="btn" @click="resetPassword(i)">重置密码</a>
				</div>
			</div>
		</div>
		<div style="height: 50px;"></div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			loginlist: [],
			login: {},
			street: '',
			keyword: ''
		}
	},
	methods: {
		deleteUser: function (i) {
			this.login = this.loginlist[i];
			this.$http.get(this.GLOBAL.base + 'deleteMiniLogin?id=' + this.login.ownerId).then(function (msg) {
				if (msg.bodyText === '1') {
					alert('删除成功');
				} else {
					alert('删除失败');
				}
				this.getAllLogin();
			})
		},
		resetPassword: function (i) {
			this.login = this.loginlist[i];
			this.$http.post(this.GLOBAL.base + 'resetMiniPassword', this.login, { emulateJSON: true }).then(function (msg) {
				alert(msg.bodyText);
				this.getAllLogin();
			})
		},
		getAllLogin: function () {
			this.$http.get(this.GLOBAL.base + 'getAllMiniLogin', {
				params: {
					street: this.street,
					keyword: this.keyword
				}
			}).then(
				function (msg) {
					this.loginlist = msg.body;
				}
			)
		}
	},
	mounted() {
		this.getAllLogin();
	}
}
</script>

<style>
.userlist {
	padding: 15px;
	width: 100%;
	flex-wrap: wrap;
}

.user {
	width: 30%;
	height: 100px;
	background-color: white;
	margin-bottom: 15px;
	padding: 10px;
	margin-left: 3%;
}

.userleft,
.usermiddle,
.userright {
	height: 100%;
}

.usermiddle h5 {
	padding-left: 10px;
}

.classone {
	color: lightseagreen;
}

.classtwo {
	color: #808080;
}
</style>
